import { inject, Injectable } from '@angular/core';

import { BaasAppState } from '@lvflanders/bar';
import { BarInitializedHook } from '@lvflanders/bar-ng';

import { DIDO_CORE_CONSTANTS } from '../dido-core.constants';
import { DidoCoreOptions } from '../models/dido-core-options.model';
import { DidoCoreStateService } from './dido-core-state.service';

@Injectable()
export class DidoCoreInitializedHook implements BarInitializedHook {
    readonly #state = inject(DidoCoreStateService);
    readonly #appState = inject(BaasAppState);
    readonly #options = inject(DidoCoreOptions);

    run() {
        // set some global state and use keyof because readonly
        const didoWebUrlKey: keyof DidoCoreStateService = 'didoWebUrl';
        this.#state[<any>didoWebUrlKey] = this.#defineDidoWebUrl();
    }

    #defineDidoWebUrl(): string {
        if (location.hostname == 'localhost') {
            // if localhost client and this bundle is build for local
            // this means we are in the DIDO solution: just use the URL of DIDO web localhost
            if (this.#options.local) {
                // NOTE that the DIDO web process is hosted somewhere else (other localhost)
                // this is set in the webpack config with define plugin
                return 'https://localhost:4300/';
            }
            // if localhost client and this bundle is build for DEV
            // this means we need to use the DEV url
            else {
                return this.#appState.location.release.origin + DIDO_CORE_CONSTANTS.DIDO_WEB_URL_SEGMENT;
            }
        }
        // we are on the deployed environment: just use current host name
        else {
            return location.origin + DIDO_CORE_CONSTANTS.DIDO_WEB_URL_SEGMENT;
        }
    }
}
